import React from "react";
import AppsIcon from "@mui/icons-material/Apps";
import EcoIcon from "@mui/icons-material/Spa";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import EggAltIcon from "@mui/icons-material/EggAlt";
import BakeryDiningIcon from "@mui/icons-material/BakeryDining";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import SetMealIcon from "@mui/icons-material/SetMeal";
import KitchenIcon from "@mui/icons-material/Kitchen";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import CategoryIcon from "@mui/icons-material/Category";

/** Fallback category list mirroring the mockup, used when the backend has none. */
export const FALLBACK_CATEGORIES = [
  "Fresh Produce", "Packaged Grocery", "Dairy & Eggs", "Bakery", "Beverages",
  "Frozen Foods", "Meat & Seafood", "Pantry Essentials", "Cleaning & Supplies",
];

const ICONS: Record<string, React.ReactElement> = {
  "all products": <AppsIcon fontSize="small" />,
  "fresh produce": <EcoIcon fontSize="small" />,
  "packaged grocery": <Inventory2Icon fontSize="small" />,
  "dairy & eggs": <EggAltIcon fontSize="small" />,
  "bakery": <BakeryDiningIcon fontSize="small" />,
  "beverages": <LocalCafeIcon fontSize="small" />,
  "frozen foods": <AcUnitIcon fontSize="small" />,
  "meat & seafood": <SetMealIcon fontSize="small" />,
  "pantry essentials": <KitchenIcon fontSize="small" />,
  "cleaning & supplies": <CleaningServicesIcon fontSize="small" />,
};

export const iconForCategory = (name: string): React.ReactElement =>
  ICONS[name.trim().toLowerCase()] ?? <CategoryIcon fontSize="small" />;
